import React, { useEffect } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const ThermalInvoiceServices = ({ subTotal, ITBIS, ITBISValue, paymentMethod, formValues, selectedServices, cashPaid, total, pendingToPay, employee }) => {
  const currentDate = new Date();
  const hours = currentDate.getHours();
  const minutes = currentDate.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
  const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}/${(currentDate.getMonth() + 1).toString().padStart(2, '0')}/${currentDate.getFullYear()} ${formattedHours}:${minutes} ${ampm}`;
  const formatDateStart = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
    return `${day}/${month}/${year} ${formattedHours}:${minutes} ${ampm}`;
  };
  const formatDateEnd = (dateString) => {
    const date = new Date(dateString);
    const day = (date.getDate() - 2).toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
    return `${day}/${month}/${year} ${formattedHours}:${minutes} ${ampm}`;
  };
  useEffect(() => {
    console.log('formValues', formValues);
  }, []);
  return (
    <Box
      sx={{ minWidth: 320, padding: 1.5, backgroundColor: '#fff', border: '1px solid #ccc', minHeight: 'Calc(100vh - 100px)' }}
    >
      <Box sx={{ textAlign: 'center', marginBottom: 3, marginTop: 4 }}>
        <div className='invoice-header-container' style={{ marginBottom: '20px' }}>
          <Typography variant="h6">D'Princess Santiago</Typography>
          <span style={{ fontSize: '12px', lineHeight: '1.2em' }}>Edificio Comercial La Fuente, Av. Yapur Dumit esq, Santiago de los Caballeros 51000</span>
        </div>
        <div style={{ width: '100%', textAlign: 'left', marginBottom: '15px', fontSize: '14px' }}>
          {formattedDate}
        </div>
        {formValues.event && <div className='selected-barber-container' style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: "space-around", fontSize: '14px', borderBottom: '1px dashed black', paddingBottom: '10px', borderTop: '1px dashed black', paddingTop: '10px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h7">Fecha de alquiler:</Typography>
            <Typography variant="h7">Fecha de devolución:</Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h7" sx={{ fontSize: '13px' }}>{formatDateStart(formValues.event[0].eventDateStart)}</Typography>
            <Typography variant="h7" sx={{ fontSize: '13px' }}>{formatDateEnd(formValues.event[0].eventDateEnd)}</Typography>
          </Box>
        </div>}
        <div className='selected-barber-container' style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: "center", fontSize: '14px', borderBottom: '1px dashed black', paddingBottom: '10px', paddingTop: '10px', textAlign: 'center' }}>
          <Typography variant="h7">FACTURA DE CONSUMO ELECTRÓNICA</Typography>
        </div>
      </Box>
      <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
        <Table size="small" aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ borderBottom: '2px dashed black', fontWeight: 'bold' }}>SERVICIOS</TableCell>
              {ITBIS && <TableCell align="right" sx={{ borderBottom: '2px dashed black', fontWeight: 'bold' }}>ITBIS</TableCell>}
              <TableCell align="right" sx={{ borderBottom: '2px dashed black', fontWeight: 'bold' }}>VALOR</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              selectedServices.length > 0 && selectedServices.map((service, index) => (
                <TableRow key={index}>
                  <TableCell component="th" scope="row" sx={{ border: 0, margin: 0, padding: '5px 0px 5px 0px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2em' }}>
                      <span>{service.serviceName}</span>
                      <span style={{ fontSize: '12px' }}>
                        {service.quantity} × {
                          service.priceWDisc
                            ? (typeof service.priceWDisc === 'string'
                              ? parseFloat(service.priceWDisc.replace(/,/g, '')).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                              : service.priceWDisc.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            )
                            : (typeof service.servicePrice === 'string' ? parseFloat(service.servicePrice.replace(/,/g, '')) : service.servicePrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                        }
                      </span>
                      {
                        service.discountApplied > 0 && <span style={{ fontSize: '12px' }}>({service.discountApplied}% descuento)</span>
                      }
                    </div>
                  </TableCell>
                  {ITBIS &&
                    <TableCell align="right" sx={{ border: 0, margin: 0, padding: 0 }}>
                      {((typeof service.servicePrice === 'string' ? parseFloat(service.servicePrice.replace(/,/g, '')) : service.servicePrice) * ITBISValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                  }
                  <TableCell align="right" sx={{ border: 0, margin: 0, padding: 0, width: '70%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2em' }}>
                      <span className='service-price'>
                        RD$ {
                          (typeof service.priceWDisc === 'number' && (service.priceWDisc > 0)
                            ? Number(service.priceWDisc) > 0 && (Number(service.priceWDisc) * service.quantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            : (typeof service.servicePrice === 'string'
                              ? (Number(parseFloat(service.servicePrice.replace(/,/g, ''))) * service.quantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                              : (Number(service.servicePrice) * service.quantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            )
                          )
                        }
                      </span>
                      {
                        (service.amountPaid && service.amountPaid > 0) ?
                          <span style={{ fontSize: '12px' }}>(RD$ {Number(service.amountPaid).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} pagados)</span> : null
                      }
                      {
                        ((service.amountPaid && service.amountPaid > 0) && (service.amountPaid < (typeof service.priceWDisc === 'number' && service.priceWDisc > 0 ? (Number(service.priceWDisc) * service.quantity) : (typeof service.servicePrice === 'string' ? (Number(parseFloat(service.servicePrice.replace(/,/g, ''))) * service.quantity) : (Number(service.servicePrice) * service.quantity)))))
                          ? <span style={{ fontSize: '12px' }}>(RD$ {(typeof service.priceWDisc === 'number' && service.priceWDisc > 0 ? ((Number(service.priceWDisc) * service.quantity) - service.amountPaid) : (typeof service.servicePrice === 'string' ? ((Number(parseFloat(service.servicePrice.replace(/,/g, ''))) * service.quantity) - service.amountPaid) : (Number(service.servicePrice) * service.quantity) - service.amountPaid)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} pendientes)</span>
                          : service.amountPaid ? <span style={{ fontSize: '12px' }}>(Pagado)</span> : <span style={{ fontSize: '12px' }}>(RD$ {(typeof service.priceWDisc === 'number' && service.priceWDisc > 0 ? (Number(service.priceWDisc) * service.quantity) : (typeof service.servicePrice === 'string' ? (Number(parseFloat(service.servicePrice.replace(/,/g, ''))) * service.quantity) : (Number(service.servicePrice) * service.quantity))).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} pendientes)</span>
                      }
                    </div>
                  </TableCell>
                </TableRow>
              ))
            }
            <TableRow sx={{ paddingTop: 5, borderTop: '2px dashed black' }}>
              <TableCell component="th" scope="row" sx={{ border: 0, fontWeight: 'bold', width: '40%' }}>
                TOTAL FACTURADO:
              </TableCell>
              <TableCell align="right" sx={{ border: 0, fontWeight: 'bold' }}>
                RD$ {Number(total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
            </TableRow>
            <TableRow sx={{ paddingTop: 5 }}>
              <TableCell component="th" scope="row" sx={{ border: 0, fontWeight: 'bold', width: '40%' }}>
                MONTO PAGADO
              </TableCell>
              <TableCell align="right" sx={{ border: 0, fontWeight: 'bold' }}>
                RD$ {Number(subTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
            </TableRow>
            <TableRow sx={{ paddingTop: 5 }}>
              <TableCell component="th" scope="row" sx={{ border: 0, fontWeight: 'bold', width: '40%' }}>
                PENDIENTE POR PAGAR:
              </TableCell>
              <TableCell align="right" sx={{ border: 0, fontWeight: 'bold' }}>
                RD$ {Number(pendingToPay).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
            </TableRow>
            <TableRow sx={{ marginTop: 0 }}>
              <TableCell component="th" scope="row" sx={{ border: 0, fontWeight: 'bold', width: '40%' }}>
                {paymentMethod.toUpperCase()}
              </TableCell>
              <TableCell align="right" sx={{ border: 0, fontWeight: 'bold' }}>
                {cashPaid > 0 ? `RD$ ${Number(cashPaid).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'RD$ 0.00'}
              </TableCell>
            </TableRow>
            <TableRow sx={{ marginTop: 0 }}>
              <TableCell component="th" scope="row" sx={{ border: 0, fontWeight: 'bold', width: '40%' }}>
                CAMBIO
              </TableCell>
              <TableCell align="right" sx={{ border: 0, fontWeight: 'bold' }}>
                {(cashPaid && (Number(cashPaid) > Number(subTotal) * ITBISValue) && paymentMethod === 'efectivo')
                  ? 'RD$ ' + Number(Math.floor((Number(cashPaid) - Number(subTotal) * ITBISValue))).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                  : 'RD$ 0.00'}
              </TableCell>
            </TableRow>
            <TableRow sx={{ marginTop: 0, width: '100%' }}>
              <TableCell scope="row" colSpan={3} sx={{ border: 0, fontWeight: 'bold', fontSize: '12px', paddingTop: 4, textAlign: 'center' }}>
                L atendió: {employee.employeeName}
              </TableCell>
            </TableRow>
            <TableRow sx={{ marginTop: 0, width: '100%' }}>
              <TableCell scope="row" colSpan={3} sx={{ border: 0, fontWeight: 'bold', paddingTop: 2, textAlign: 'center' }}>
                GRACIAS POR PREFERIRNOS
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ThermalInvoiceServices;
